import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Table,
  Input,
  Label
} from "reactstrap";
import { connect } from "react-redux";
import { profilePicValidityCheck } from "../../../../utils/constants";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { toastContainer } from "../../../../utils/toast";
import * as actionCreators from "../../../../modules/actions";
import EditActionRow from "./EditActionRow";
import { deepClone } from "../../../../utils/copyObject";

function ShareActionsModal({
  currentTrivia,
  open,
  onClose,
  updateTriviaObject,
  data
}) {
  const [actions, setActions] = useState([]);
  const [messageTitle,setMessageTitle] = useState("")

  const handleShareActions = () => {
    const payload = {
      actions,
      triviaName: currentTrivia.name,
      triviaId: currentTrivia._id,
      sharedWithUsers: currentTrivia.sharedWithUsers,
      messageTitle
    };

    axios
      .post(url.shareSurveyInsightsActions, payload)
      .then(({ data }) => {
        if (data.data) {
          updateTriviaObject({
            selectedActions: data.data.selectedActions,
          });
          toastContainer("Shared successfully", "success");
          onClose();
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {
          toastContainer(error.response.data.errors.message, "error");
        }
      });
  };

  useEffect(() => {
    if (
      data &&
      Array.isArray(data)
    ) {
      setActions(data);
    }
  }, [data]);

  useEffect(() => {
    if (
      data &&
      Array.isArray(data)
    ) {
      setActions(data);
    }
  }, []);

  const handleActionUpdate = (value, index) => {
    const actionsArray = [...actions];


    actionsArray[index].action = value;
    actionsArray[index].lastUpdateActionText = new Date();

    setActions(actionsArray)
  
  };


  return (
    <Modal isOpen={open}>
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Share actions
      </ModalHeader>

      <ModalBody>
        <div>
          <div className="my-2">
            <Label>Message title</Label>
            <Input value={messageTitle} onChange={e => setMessageTitle(e.target.value) } />
          </div>
          <div className="my-2">
            <Alert color="info">
              Actions will be shared via same method users received survey.
            </Alert>
          </div>
          <div className="my-1">
            <b>Actions:</b>
          </div>
          <ul>
          {actions.map((item, index) => {
            return (
              <li className="my-1">
                <EditActionRow
                  index={index}
                  action={item.action}
                  handleSave={handleActionUpdate}
                />
              
              </li>
            );
          })}
          </ul>
          
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Cancel</Button>{" "}
        <Button
          color="success"
          disabled={
            currentTrivia.sharedWithUsers &&
            currentTrivia.sharedWithUsers.length == 0
          }
          onClick={handleShareActions}
        >
          Share
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareActionsModal);
